import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NewVersionNotice } from './core/errors/new-version-notice';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <!--
      Shown when a lazy route fails to load, which means this tab is running
      against a deploy that has been replaced. Without it the page simply half
      renders: the user clicked a menu item, nothing happened, and the only
      evidence is a console message about a MIME type.

      Placed above the outlet and not inside a route, because the failure is
      the router failing to reach one.
    -->
    @if (version.stale()) {
      <div class="new-version" role="alert">
        <span>
          A new version of ESMS has been released. Reload to continue —
          anything you have typed on this page will be lost.
        </span>
        <button type="button" data-reload (click)="version.reload()">Reload</button>
      </div>
    }
    <router-outlet />
  `,
  styles: [`
    .new-version {
      position: fixed; inset: 0 0 auto 0; z-index: 1000;
      display: flex; align-items: center; justify-content: center; gap: 16px;
      padding: 12px 20px; font-size: 14px; line-height: 20px;
      background: var(--status-warning-tint); color: var(--status-warning-text);
      border-bottom: 1px solid rgba(176, 125, 42, .4);
    }
    .new-version button {
      font: inherit; font-weight: 500; cursor: pointer;
      padding: 6px 12px; border-radius: 4px;
      border: 1px solid rgba(176, 125, 42, .5);
      background: #fff; color: var(--status-warning-text);
    }
    @media (max-width: 640px) {
      .new-version { flex-direction: column; gap: 8px; text-align: center; }
    }
  `],
})
export class AppComponent {
  version = inject(NewVersionNotice);
}
